<template>
  <div
    :class="{ 'has-logo': showLogo }"
    :style="{
      backgroundColor:
        settings.sideTheme === 'theme-dark'
          ? variables.menuBackground
          : variables.menuLightBackground,
    }"
  >
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-tabs v-model="activeName" stretch @tab-click="handleClick" class="menu-tabs">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="收藏" name="collect">收藏</el-tab-pane>
    </el-tabs>
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="
          settings.sideTheme === 'theme-dark'
            ? variables.menuBackground
            : variables.menuLightBackground
        "
        :text-color="
          settings.sideTheme === 'theme-dark'
            ? variables.menuColor
            : variables.menuLightColor
        "
        :unique-opened="true"
        :active-text-color="settings.theme"
        :collapse-transition="false"
        mode="vertical"
        @select="select"
        v-if="activeName == 'all'"
      >
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
          :activeName="activeName"
        />
      </el-menu>
      <el-menu
        v-if="activeName == 'collect'"
        default-active="2"
        class="el-menu-vertical-demo"
        :background-color="
          settings.sideTheme === 'theme-dark'
            ? variables.menuBackground
            : variables.menuLightBackground
        "
        :text-color="
          settings.sideTheme === 'theme-dark'
            ? variables.menuColor
            : variables.menuLightColor
        "
        :unique-opened="true"
        :active-text-color="settings.theme"
        :collapse-transition="false"
      >
        <!-- <el-menu-item v-for="(item,index) in collectArr" :key="item.path  + index">
                    <svg-icon :icon-class=item.icon />
                    <span slot="title">{{item.menuName}}</span>
                </el-menu-item> -->
        <sidebar-item
          v-for="(route, index) in collectArr"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
          :activeName="activeName"
          @getMenuCollect="getMenuCollect"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.scss";
import { getMenuCollect } from "@/api/system/menu";
import { statistics } from "@/api/menu";

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["sidebarRouters", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  data() {
    return {
      activeName: "all",
      collectArr: [],
      activeRoute: {},
    };
  },
  // mounted() {
  //     this.sidebarRouters.forEach(item => {
  //         console.log(item);
  //     });
  // },
  methods: {
    select(index, indexPath) {
      index = index.substring(index.lastIndexOf("/") + 1);
      this.activeRoute = this.$store.state.permission.newRoutes.filter((item, i) => {
        return index === item.path;
      });
      let json = {
        menuId: this.activeRoute.slice(-1)[0].menuId,
        userId: this.$store.state.user.userId,
      };
      statistics(json).then((res) => {
        console.log(res);
      });
    },
    handleClick(tab, event) {
      if (this.activeName == "collect") {
        this.getMenuCollect();
      }
    },
    getMenuCollect() {
      console.log(111);
      getMenuCollect()
        .then((res) => {
          let arr = [];
          res.data.forEach((item, index) => {
            let obj = {
              meta: {},
            };
            obj.children = item.children;
            obj.meta.icon = item.icon;
            obj.meta.title = item.menuName;
            obj.path = item.path;
            arr.push(obj);
          });
          this.collectArr = arr;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-tabs.el-tabs--top {
  ::v-deep .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  ::v-deep .el-tabs__item.is-top:last-child {
    padding-right: 20px;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #304156;
  }
  ::v-deep .el-tabs__active-bar {
    display: none;
  }
}
::v-deep .el-tabs__item.is-active {
  color: #1890ff;
}
::v-deep .el-tabs__item {
  color: #fff;
}
</style>
